import { render, staticRenderFns } from "./OrderedItem.vue?vue&type=template&id=6cb2a764"
import script from "./OrderedItem.vue?vue&type=script&lang=js"
export * from "./OrderedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports